import styles from "./Settings.module.scss";
import { useTranslation } from "react-i18next";

const LegalInformation = () => {
    const { t } = useTranslation();

    return (
        <div className={styles._container}>
            <div className={`${styles.wrapper} ${styles.textContent}`}>
                <h1>{t("legalInformation.title")}</h1>
                <p>{t("legalInformation.paragraph1")}</p>
                <p>{t("legalInformation.paragraph2")}</p>
            </div>
        </div>
    );
};

export default LegalInformation;
